<h1 mat-dialog-title>
  <app-titulo-paginas titulo="Assinatura"></app-titulo-paginas>
</h1>
<mat-dialog-content>
  <canvas class="signature-pad-canvas" #canvas style="touch-action: none;"></canvas>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <div class="painel-footer">
      <button type="button" class="btn btn-danger" (click)="clear()">Limpar</button>
      <button type="button" class="btn btn-warning" (click)="undo()">Voltar</button>
      <button type="button" class="btn btn-success" [disabled]="isCanvasBlank()"
          (click)="send()">Salvar</button>
      <button type="button" class="btn btn-secondary" (click)="dialog.close()">Cancelar</button>

  </div>
</mat-dialog-actions>
